
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M28.97 43.51v14.28M18.97 57.79h20M15 36.87a18 18 0 0032-11.34V22.7M44.34 6.53H11v19"}}),_c('path',{attrs:{"d":"M11 41.72a17.93 17.93 0 00-3.43-4.92 17.53 17.53 0 00-4.91-3.45 17.66 17.66 0 004.92-3.46A17.56 17.56 0 0011 25a17.55 17.55 0 008.36 8.36 17.8 17.8 0 00-4.91 3.46 17.53 17.53 0 00-3.45 4.9zM47 22.84a21.63 21.63 0 00-10.28-10.31 21.75 21.75 0 006.05-4.27 21.73 21.73 0 004.26-6 21.8 21.8 0 004.26 6.06 21.73 21.73 0 006.05 4.26 22 22 0 00-6.06 4.26 21.56 21.56 0 00-4.28 6zM29 36.39a11.06 11.06 0 0011-11.06","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    